import React from 'react'
import PropTypes from 'prop-types'
import ToolTip from '../../../ToolTip'
import classNames from 'classnames'
import './styles.scss'
import { FACT_LABEL_TOOLTIP_DELAY, FACT_LABEL_TOOLTIP_MIN_WIDTH } from '../../constants'

const FactsheetComponentLabel = ({ label, definition, required = false }) => {
  const className = classNames(
    'factsheet-component-label',
    {
      'ToolTip-Handle': !!definition
    }
  )
  return (
    <>
      <label className={className}>
        {label} {required ? '*' : ''}
        {
          definition && (
            <ToolTip
              minWidth={FACT_LABEL_TOOLTIP_MIN_WIDTH}
              position={'right'}
              showPointer={false}
              hoverDelay={FACT_LABEL_TOOLTIP_DELAY}
            >
              {definition}
            </ToolTip>
          )
        }
      </label>
    </>
  )
}

FactsheetComponentLabel.propTypes = {
  label: PropTypes.string.isRequired,
  definition: PropTypes.string,
  required: PropTypes.bool,
}

FactsheetComponentLabel.defaultProps = {
  definition: null,
  required: false,
}

export default FactsheetComponentLabel
